import { render, staticRenderFns } from "./contentBlock.vue?vue&type=template&id=487a73da&"
import script from "./contentBlock.vue?vue&type=script&lang=js&"
export * from "./contentBlock.vue?vue&type=script&lang=js&"
import style0 from "./contentBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports